export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

interface Config {
  API_URL: string;
  APP_LOG_LEVEL: LogLevel;
  SENTRY_DSN: string;
  ENV: string;
  WEB_SOCKET_URL: string;
  APP_URL: string;
}

let configLoaded = false;
let config: Config = {
  API_URL: '',
  APP_LOG_LEVEL: LogLevel.ERROR,
  SENTRY_DSN: '',
  ENV: 'production',
  WEB_SOCKET_URL: '',
  APP_URL: '',
};

type ConfigTypes = {
  [K in keyof Config]: Config[K];
};

const fetchConfig = async () => {
  const src = (document.currentScript as HTMLScriptElement)?.src || '';
  const baseUrl = src ? new URL(src).origin : '';
  const response = await fetch(`${baseUrl}/config.json`);
  const data: Config = await response.json();
  config = data;
  configLoaded = true;
  return config;
};

export const getConfig = <K extends keyof Config>(key: K): ConfigTypes[K] => config[key];

export const getConfigAsync = async <K extends keyof Config>(key: K): Promise<ConfigTypes[K]> => {
  return new Promise((resolve) => {
    if (typeof config[key] !== 'undefined' && configLoaded) {
      return resolve(config[key]);
    }

    setTimeout(() => {
      resolve(getConfigAsync(key));
    }, 50);
  });
};

export default fetchConfig;
